function NotFound() {
  return (
    <div className="m-auto max-w-6xl w-3/4">
      <div className="block p-6 bg-white border border-gray-200 rounded-lg shadow-sm dark:bg-gray-800 dark:border-gray-700">
        <h1 className="mb-2 text-2xl md:text-3xl tracking-tight text-gray-900 dark:text-white">404 Not found</h1>
      </div>

    </div>
  );
};

export default NotFound;